/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioItemSchema } from './scenarioItemSchema';

export const paginatedResultScenarioItemSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(scenarioItemSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
  totalCount: z.int().nullish(),
});
